import store from "@/store";
import confirmations from "./confirmations";
import alerts from "@/components/alerts/alert";
import Api from "@/api/index";
import defaultErrorPaginate from "@/api/defaultErrorPaginate";
import AuthenticationService from "@/services/AuthenticationService";

const attendances_teacher = {
  namespaced: true,
  state: {
    loading: false,
    datas: {},
    detail: {},
    attendance_detail: {},
    event: {},
    my: {},
    students: [],
    queryParam: {},
    modalAbsen: false,
    modalAbsenDetail: false,
    reports: [],
    count: "0",
    teachers: [],
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
    getEvent(state) {
      return state.event;
    },
    getMy(state) {
      return state.my;
    },
    getReports(state) {
      return state.reports;
    },
    count(state) {
      return state.count;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_EVENT(state, datas) {
      state.event = datas;
    },
    SET_MY(state, datas) {
      state.my = datas;
    },
    SET_STUDENTS(state, datas) {
      state.students = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_MODAL_ABSEN(state, data) {
      state.modalAbsen = data;
    },
    SET_MODAL_ABSEN_DETAIL(state, data) {
      state.modalAbsenDetail = data;
    },
    SET_REPORTS(state, data) {
      state.reports = data;
    },
  },
  actions: {
    async getCount({ commit, state }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("backoffice/attendances/student/count/all")
        .then(({ data }) => {
          state.count = data;
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          commit("SET_DATAS", error.data);
        });
    },
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate(
        "backoffice/attendances/teacher/page",
        payload
      ).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
    onRefresh({ state }) {
      store.dispatch("attendances_teacher/paginate", state.queryParam);
    },
    setState({ state }, payload) {
      state[payload[0]] = payload[1];
    },
    onAction({ commit, state }, payload) {
      if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      } else if (payload[1] === "Update") {
        commit("SET_MODAL_ABSEN", true);
        store.dispatch("attendances_teacher/getEvent", payload[0]["event_id"]);
        store.dispatch(
          "attendances_teacher/getStudentEvent",
          payload[0]["event_id"]
        );
      } else if (payload[1] === "IN") {
        state.attendance_detail = payload[0];
        store.dispatch("attendances_teacher/getTeachers", payload[0]);
      } else if (payload[1] === "DetailAbsen") {
        commit("SET_MODAL_ABSEN", false);
        commit("SET_MODAL_ABSEN_DETAIL", true);
        state.attendance_detail = payload[0];
        store.dispatch("attendances_teacher/getTeachers", payload[0]);
      }
    },
    async getEvent({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet("backoffice/event/" + payload).then(({ data }) => {
        commit("SET_EVENT", data.record);
        commit("SET_MY", data.account);
        commit("SET_LOADING", false);
      });
    },
    async getStudentEvent({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet("students/event/" + payload).then(({ data }) => {
        commit("SET_STUDENTS", data);
        commit("SET_LOADING", false);
      });
    },
    async getSchedule({ commit, state }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet("backoffice/schedule/student/" + payload).then(
        ({ data }) => {
          state.detail = data;
          commit("SET_LOADING", false);
        }
      );
    },
    async getTeachers({ commit, state }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet(
        "backoffice/attendances/teachers/" + payload["attendance_id"]
      ).then(({ data }) => {
        commit("SET_MODAL_ABSEN", true);
        if (data.guru_tambahan.length === 0) {
          data.guru_tambahan[0] = {
            teacher_id: payload["teacher_id"],
            kehadiran: null,
            peran: "Pengajar",
          };
        }
        data.guru_tambahan.sort(function (a, b) {
          return new Date(a.created_at) - new Date(b.created_at);
        });
        state.detail = data;
        commit("SET_LOADING", false);
      });
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(
        payload[0],
        `attendances_teacher/${payload[1]}`
      );
    },
    async create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      state.event.students = payload;
      return await AuthenticationService.post(
        "backoffice/attendances/student",
        state.event
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_ABSEN", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("attendances_teacher/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async absen({ commit, state }, payload) {
      payload["teachers"] = state.teachers;
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.put(
        "backoffice/attendances/teachers/" + payload.attendance_id,
        payload
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_ABSEN", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("attendances_teacher/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async reportPaginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate(
        "report/attendances/student/page",
        payload
      ).then(({ data }) => {
        commit("SET_REPORTS", data);
        commit("SET_LOADING", false);
      });
    },
  },
};

export default attendances_teacher;
